import styled, { css } from 'styled-components';
import { Title } from '@lux/title';
import { BackgroundColor, Spacer } from '@lux/tokens';
import { screenSmallerThan, Screen } from '@client/styles/styled-components/breakpoints';

export const OuterWrapper = styled.main`
    background-color: ${BackgroundColor.mylounge};
    position: relative;

    .lux-grid-page-layout {
        ${screenSmallerThan(Screen.smallTablet)} {
            padding-left: 0;
            padding-right: 0;
        }
    }
`;

export const Wrapper = styled.section<{ $isLastContainer?: boolean }>`
    position: relative;
    background-color: ${BackgroundColor.mylounge};
    ${({ $isLastContainer }) =>
        $isLastContainer &&
        css`
            padding-bottom: 35px;
        `};
`;

export const MoreCampaignTitle = styled(Title)`
    margin-top: ${Spacer.M};
    text-align: center;
`;

export const MoreCampaignsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacer.L};
    margin: ${Spacer.M} ${Spacer.S} ${Spacer.L};
`;
